import React from 'react';
import { useIntl } from 'react-intl';

import { PrismicRichText } from 'types/prismicRichtext';
import { PrismicRelatedItemsFields } from 'types/prismic';
import { Prismic__LinkableWithType } from 'types/prismicLink';

import { asText } from 'components/rich-text/RichText';

import { ImageContainer } from './ImageContainer';
import { getTypeDataFromLinkable } from 'utils/prismic';
import { Grid } from 'components/grid/Grid';
import { Card } from 'components/card/Card';

interface IRelatedItemsContainer {
  title: PrismicRichText;
  items: PrismicRelatedItemsFields[];
  isColumnLayout?: boolean;
}

export const RelatedItemsContainer = ({ title, items, isColumnLayout }: IRelatedItemsContainer) => {
  if (items.length === 0) {
    return null;
  }

  const intl = useIntl();

  const heading = title ? asText(title) : intl.formatMessage({ id: 'relateditems' });

  return (
    <Grid
      isColumnLayout={isColumnLayout}
      heading={heading}
    >
      {items.map((item: PrismicRelatedItemsFields, i: number) => {
        const { text, link, image, backgroundColor } = getTypeDataFromLinkable(
          item.content as Prismic__LinkableWithType
        );

        if (!text && !link && !image) {
          return null;
        }

        return (
          <Card
            key={i}
            heading={asText(text)}
            to={link ?? ''}
            image={image && <ImageContainer image={image} imageOnly />}
            color={backgroundColor}
          />
        );
      })}
    </Grid>
  );
};
